module.exports = __webpack_public_path__ + "media/30.87cb04d7.wav";